<template>
  <h-list-page class="notice-container">
    <div class="notice-btn-group">
      <div class="notice-title">{{ h_i18n('1432c7fcdba00f248023082857b52281') }}</div>
      <div class="btn-group" v-if="$route.query.isAdmin == 'true'">
        <div class="primary-btn" @click="handleAdd" style="width: 66px;">
          <img src="@/assets/img/add.png" style="width: 16px;height: 16px;margin-right: 5px;"/>{{ h_i18n('66ab5e9f24c8f46012a25c89919fb191') }}</div>
        <div class="primary-btn marginL12" @click="handleEdit" style="width: 66px;">
          <img src="@/assets/img/bianji.png" style="width: 16px;height: 16px;margin-right: 5px;"/>{{ h_i18n('95b351c86267f3aedf89520959bce689') }}</div>
        <div class="danger-btn marginL12" @click="handleDelete">
          <img src="@/assets/img/shanchu.png" style="width: 16px;height: 16px;margin-right: 5px;"/>{{ h_i18n('7fb62b30119c3797a843a48368463314') }}</div>
      </div>
    </div>
    <div style="width:100%;background: #fff;border-radius: 8px;margin:12px auto;box-sizing: border-box;padding: 16px;">
      <h-card :title="h_i18n('8915845d00976200bea46b0bfafa3bbd')" width="100%" :is-left="0" is-search>
        <h-area title-width="90px" :all-span="7">
          <h-search :title="h_i18n('9970ad07468267e2f309f1467c75bb80')">
            <h-input v-model="searchData.title" :placeholder="h_i18n('0acb4852d898f552e7b46b2cc1305645')" style="width: 300px;" clearable> </h-input>
          </h-search>
          <template #operate>
            <!-- <h-button type="primary" :loading="tableLoading" style="border-radius: 7px;" @click="getTable">查询</h-button>
            <h-button type="primary" @click="resetTable" style="border-radius: 7px;">重置</h-button> -->
            <div class="primary-btn marginL12" @click="getTable">{{ h_i18n('e5f71fc31e7246dd6ccc5539570471b0') }}</div>
            <div class="reset-btn" style="margin-left: -10px;" @click="resetTable">{{ h_i18n('4b9c3271dc2f299dc3aeffb369187513') }}</div>
          </template>
        </h-area>
      </h-card>
      <el-tabs v-model="activeName" style="margin-top: -8px;" @tab-click="handleClick">
        <el-tab-pane :label="h_i18n('1432c7fcdba00f248023082857b52281')" name="1"></el-tab-pane>
        <el-tab-pane :label="h_i18n('20faa88f0d2f0ab5f771e88deb352132')" name="2"></el-tab-pane>
        <!-- <el-tab-pane label="流程文件" name="3"></el-tab-pane> -->
        <el-tab-pane :label="h_i18n('50d52dd929a75bb9b0f4afb0b7d879e1')" name="4"></el-tab-pane>
      </el-tabs>
      <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" border :data="noticeList" height="510px"
        size="small" @selection-change="handleSelect" class="myTable"
        style="width: 100%; min-height: 510px;border-radius: 8px;border-color: #E5E6EB;" :header-cell-style="{ background: '#f1f2f8 !important' , color: '#1D2129' }">
        <el-table-column type="selection" width="50" v-if="$route.query.isAdmin == 'true'"></el-table-column>
        <el-table-column :label="h_i18n('32c65d8d7431e76029678ec7bb73a5ab')" align="left" prop="title" show-overflow-tooltip></el-table-column>
        <el-table-column :label="h_i18n('f1bd8b053770a696fc8646ca911c9520')" align="left" show-overflow-tooltip v-if="$route.query.isAdmin == 'true'" width="100">
          <template #default="{ row }">
            <span>{{ row.noticeType == '1' ? h_i18n('1432c7fcdba00f248023082857b52281') : row.noticeType == '2' ? h_i18n('20faa88f0d2f0ab5f771e88deb352132') : row.noticeType == '4' ? h_i18n('50d52dd929a75bb9b0f4afb0b7d879e1') :'' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('5ad2f695c4da24b49ba8a77a2bb01c5c')" align="left" show-overflow-tooltip v-if="$route.query.isAdmin == 'true'" width="100">
          <template #default="{ row }">
            <span>{{ row.visibleType == '0' ? h_i18n('0d7942407f51e1b3cb2e995a80ca4098') : row.visibleType == '1' ? h_i18n('b15edc81a94344441dd027c72358d605') : row.visibleType == '2' ? h_i18n('7acc1680a5f6ee408eae017701ce7ccf') : ''}}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="fileName" :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" show-overflow-tooltip>
          <template #default="{ row }">
            <span style="color:#165dff;cursor: pointer;" @click="toPDF(row)">{{ row.fileName }}</span>
          </template>
        </el-table-column>
        <el-table-column width="220" :label="h_i18n('3bdd08adab6ea90b9164b20a0e4151ac')" v-if="$route.query.isAdmin == 'true'">
          <template #default="{ row }">
             <div class="describe" v-html="row.noticeContent||'--'"></div>
          </template> 
        </el-table-column>
        <el-table-column width="120" :formatter="({uploadTime})=>formDate(uploadTime,3)" :label="h_i18n('5fb17cfefdae401de0acbc52bf309042')"></el-table-column>
      </el-table>
      <el-pagination background @current-change="handlePageChange"
        v-model:currentPage="currentPage" :page-size="10" style="display: flex;justify-content: flex-end;margin: 12px 48px 12px 0;"
        layout="total, prev, pager, next,jumper" :total="total">
      </el-pagination>
    </div>
  </h-list-page>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { noticeArray,guideListHaier,guideListSupply,process,supply,haier } from './json'
export default {
  data(){
    return{
      searchData:{},
      tableLoading: false,
      total:0,
      currentPage:1,
      noticeList:[],
      selectList:[],
      activeName:'1',
      noticeType:'1',//1:系统公告、2:操作指导书、3:流程文件、4：常见问题
      visibleType:null
    }
  },
  watch:{
    $route:{
      handler(to){
        this.activeName = to.query.activeName ? String(to.query.activeName) : '1'
      },
      immediate: true
    }
  },
  methods:{
    h_i18n,
    formDate(val, len = 3){
      if (val) {
        return this.time(val, len)
      } else {
        return "-"
      }
    },
    getTable(){
      this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
      let params = {
        current:this.currentPage,
        size:10,
        title:this.searchData.title,
        noticeType:Number(this.activeName),
        visibleType:this.visibleType
      }
      if(this.$route.query.isAdmin=='true'){
        delete params.visibleType
      }
      this.$http({
        method: "post",
        url: "/base/notice/list",
        data: params,
      }).then((res) => {
        this.closeLoading()
        this.noticeList = res.data.data.records||[]
        this.noticeList.map(item => {
          return item.checked = false
        })
        this.total = res.data.data.total
      }).catch(err=>{
        this.closeLoading()
        this.info(err.data.msg)
      })
    },
    handlePageChange(val){
      this.currentPage = val
      this.getTable()
    },
    resetTable(){
      this.searchData.title = ''
      this.getTable()
    },
    handleEdit(){
      if (this.selectList.length == 0) {
        this.info(h_i18n('12858e43f43712a6d964c3093d988b57'));
        return;
      }
      this.$router.push({
        name:"noticeAdd",
        query:{...this.$route.query,id: this.selectList[0].noticeId}
      })
    },
    handleAdd(){
      this.$router.push({
        name:"noticeAdd",
        query:{
          ...this.$route.query
        }
      })
    },
    handleDelete(){
      if (this.selectList.length == 0) {
        this.info(h_i18n('12858e43f43712a6d964c3093d988b57'));
        return;
      }
      this.info({
        message: `${h_i18n('07df7d38263f691001baa9881b1a3906')}${this.selectList.length}${h_i18n('0176c40c6aa856fad2899532da35506a')}`,
        title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          if (action == 'confirm') {
            let list = this.selectList.map(item => {
              return item.noticeId
            })
            this
              .$http({
                url: '/base/notice/deleteBatch',
                method: 'post',
                data: list,
                params:{
                  name: this.$route.query.name,
                  nickName: this.$route.query.nickName
                }
              })
              .then((res) => {
                if (res.data.data) {
                  this.success({
                    title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
                    message: h_i18n('43593d9a9591327cea1dda09c97a50e5'),
                    confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                    callback: async (action) => {
                      this.getTable();
                      this.selectList = []
                    },
                  });
                  
                } else {
                  this.warning({
                    message: res.data.msg ? res.data.msg : h_i18n('acf0664a54dc58d9d0377bb56e162092'),
                    confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
                    title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770')
                  });
                }
              })
              .catch((err) => {
                this.warning({ message: err ? err : h_i18n('acf0664a54dc58d9d0377bb56e162092'), confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'), title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
              });
          }
        }
      });
    },
    changeMethod() {
      this.postThisPageHeight()
    },
    handleSelect(item){
      console.log('item',item)
      this.selectList = [...item]
    },
    handleClick(val){
      if(top != self){
        
        this.activeName = val.paneName
        this.currentPage = 1
        this.getTable()
        return
        // 为啥要用路由呢。用了路由会判断是否登录，用回tab切换吧
      }
      this.activeName = val.paneName
      this.currentPage = 1
      this.$router.replace({
        name:'SystemNotice',
        query:{
          ...this.$route.query,
          activeName:val.props.name
        }
      })
      this.getTable()
    },
    toDetail(item){
      this.$router.push({name:'noticeDetail',query:{...this.$route.query,id:item.noticeId}})
    },
    toPDF(row){
      console.log('rowrowrowstr.includes("http");',row)
      if(row.fileUuid.includes('https')){
        window.open(row.fileUuid)
      }else{
        window.open(`https://sqm.haier.net/readFile/${row.fileUuid}`)
      }
    },
    uploadNoticeMethods () { 
      noticeArray.forEach(e => {
        console.log('3242342eeeee',e)
        setTimeout(()=>{
          this.$http({
            method: "post",
            url: "/base/notice/saveNotice",
            data: {
              ...e
            },
          }).then((res) => {
            console.log(res, "savesavesavesavesavesavesavesave");  
          }).catch(err=>{
            this.info(err.data.msg)
          })
        },2000)
      })
    }
  },
  mounted(){
    if(this.$route.query.isAdmin){
      this.visibleType = 0
    }else{
      if(this.$route.query.roleCode&&((this.$route.query.roleCode).includes('S')||(this.$route.query.roleCode).includes('s'))){
        this.visibleType = 2
      }else {
        this.visibleType = 1
      }
    }
    this.getTable()
//     visibleType 可见类型（0-全部可见，1-海尔可见，2-供应商可见）
// isPublish 是否发布：0-未发布，1-已发布
// this.uploadNoticeMethods()
    // console.log('uploadNoticeMethods',uploadNoticeMethods())
  }
}
</script>

<style scoped>
.click-btn{
  color: #3a8ee6;
  cursor: pointer;
}
/* .haier-list-page .el-table .cell{
  text-align: left !important;
}
.el-table th>.cell{
  text-align: left !important;
}
body .el-table .cell{
  text-align: left !important;
} */
.is-hwork .el-table th{
  background: #F1F2F8 !important;
  color: #1D2129 !important;
  font-size: 14px;
}
</style>

<style lang="scss" scoped>
.notice-container{
  height: 100%;
  padding: 0;
  margin: 0px auto;
  border-radius: 8px;
  box-sizing: border-box;
  .notice-btn-group{
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    height: 48px;
    padding: 0 16px;
    .btn-group{
      display: flex;
      flex-direction: row;
      // margin-right: 16px;
    }
    .notice-title{
      color: #1D2129;
      font-size: 18px;
    }
  }
  .describe{
    // white-space: pre-wrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: flex;
    // -webkit-line-clamp: 1;
    // -webkit-box-orient: vertical;
    height: 25px;
    line-height: 25px;
    width: 95%;
    p{
      line-height: 25px;
      width: 95%;
    }
    div{
      line-height: 25px;
      width: 95%;
    }
    span{
      display: inline-block;
      line-height: 25px;
      width: 95%;
    }
    label{
      display: inline-block;
      line-height: 25px;
      width: 95%;
    }
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // word-break: break-all;
  }
  .notice-title{
    cursor: pointer;
    &:hover{
      color: #165dff;
    }
  }
  .search-btn{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 0px 0 16px 0;
  }
  .primary-btn{
    min-width: 60px;
    max-width: 80px;
    height: 30px !important;
    line-height: 30px !important;
    text-align: center;
    background: #fff;
    border: 1px	solid#165DFF;
    color: #165dff;
    border-radius: 8px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .reset-btn{
    width: 60px;
    height: 30px !important;
    line-height: 30px !important;
    text-align: center;
    background: #fff;
    border: 1px	solid#C9CDD4;
    color: #1D2129;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
  }
  .danger-btn{
    width: 90px;
    height: 30px !important;
    line-height: 30px !important;
    text-align: center;
    background: #fff;
    border: 1px	solid#F53F3F;
    color: #F53F3F;
    border-radius: 8px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .marginL12{
    margin-left: 12px;
  }
  .list-content{
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    margin-top: 1px;
    .list-style{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      box-sizing: border-box;
      padding: 0 16px;
      .item1{
        margin-right: 24px;
      }
      .item2{

      }
    }
  }
}
</style>

<style lang="scss">
.is-card-hwork{
  padding: 0 !important; 
}
.is-hwork .operate{
  width: 150px;
}
.el-tabs__item.is-active{
  color: #165dff;
}
.el-tabs__active-bar{
  background: #165dff;
  height: 3px;
  border-radius: 1.5px;
}
.el-tabs__nav-wrap::after{
  background: #E5E6EB;
  height: 1px;
}
.el-tabs__item:hover{
  color: #165dff;
}
.is-hwork{
  box-sizing: border-box;
  width: 100%;
}
.haier-list-page .el-table .cell{
  text-align: left !important;
  padding-left: 12px !important;
}
.el-table th>.cell{
  text-align: left !important;
}
body .el-table .cell{
  text-align: left !important;
}
</style>